import React, { useState, useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Typography, Divider } from '@material-ui/core';
import { getEvents } from "../../../store/constructs/events/selectors";
import { marginBottom } from "../../../config/styles";
import DeleteCancel from "../../atoms/buttons/DeleteCancel";
import { getUserTriggers } from '../../../store/constructs/user_triggers/selectors'
import { getRoutingRules } from "../../../store/constructs/routing_rules/selectors";
import { invokePostService, invokeGetService, setReRender, toggleRightDrawer, setFocusElement, handleSnackBar } from "../../../store/global/actions";
import { useParams } from 'react-router-dom';
import { getBottomDrawerStatus, getRightDrawerStatus } from '../../../store/global/selectors';


export default function DeleteEvent({ eventId, onClose, onCompletion, onDeleteConfirmation, setShowDeleteEventAlert}) {

    const dispatch = useDispatch();
    const events = useSelector(getEvents);
    const event = events.find(item => item.id === eventId);
    const rrdefs = useSelector(getRoutingRules);
    const bottomDrawerStatus = useSelector(getBottomDrawerStatus);
    const rightDrawerStatus = useSelector(getRightDrawerStatus);
    
    
    const params = useParams();
    const [isDeleting, setIsDeleting] = useState(false);
    const [eventParent, setEventParent] = useState('');

    const rrdefsForEvent = rrdefs.filter(rrdef => rrdef.attributes.tcmd === eventId);
    let userTriggers = useSelector(getUserTriggers);
    const userTriggerforEvent = userTriggers.filter(ut => ut.attributes.op === eventId);

    const associations = [];
    userTriggerforEvent.forEach(ut => associations.push(`User Trigger "${ut.attributes.desc?.length < 20 ? ut.attributes.desc : ut.attributes.desc?.substr(0, 50) + '...'}"`))
    rrdefsForEvent.forEach(rrdef => associations.push(`Routing Rule ${rrdef.name}`))

    useEffect(() => {
        if(eventId && !isDeleting){
            dispatch(invokeGetService('getEventParent', [eventId]))
                .then((response) => {
                    if (response.status) {
                        setEventParent(response.data)
                    }
                }).catch(error => {
                    console.log('Fetching event parent failed.', error);
                })
        }
    }, [])



    const onDelete = async () => {
        if(onDeleteConfirmation) onDeleteConfirmation({id: eventId, type: "event"});
        setIsDeleting(true);
        dispatch(invokePostService('deleteEvent', { eventId: eventId, transactionId: eventParent ? eventParent : params?.transaction }, [eventId]))
            .then((response) => {
                if (response?.status) {
                    onCompletion(undefined, 'delete');
                } else {
                    if(response?.code === 254){
                        setShowDeleteEventAlert(false);
                    }else if(response?.code === 255) {
                        if(!bottomDrawerStatus && rightDrawerStatus) dispatch(toggleRightDrawer());
                        dispatch(setReRender());
                    } 
                    
                    if (response?.message) {
                        dispatch(handleSnackBar({ open: true, message: response?.message, severity: "error" }));
                    }
                }
                
            })
            .catch(error => {
                console.error(`Delete event failed. ${error}`);
                dispatch(handleSnackBar({ open: true, message: "Delete event failed", severity: "error" }));
            })
            setIsDeleting(false);
    }

    return (
        <>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="h6" >Delete</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid xs={12} style={marginBottom}>

                    {associations.length > 0 && <Fragment>
                        <Typography> Deleting the event will delete following entities </Typography>
                    </Fragment>}

                    <ol>
                        {associations.map((item, index) =>
                            <li key={index}>  {item} </li>
                        )}
                    </ol>

                    <Fragment>
                        <Typography>Are you sure you want to delete the Event {event?.name} ?  </Typography>
                    </Fragment>

                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                    <DeleteCancel onCancel={onClose} onDelete={onDelete} disableButton={isDeleting} content={isDeleting ? 'Deleting..' : 'Delete'} />
                </Grid>

            </Grid>
        </>
    )
}
